import APIService from '../../services/api'
import {getCatalogs} from '../../services/data'

import {
  SEARCH_EXHIBITION_SECTION_LIST,
  FETCH_RESULT_LIST,
  FETCH_RESULT_FILTERED,
  UPDATE_RESULT_LIST,
  UPDATE_RESULT_FILTERED,
  GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN,
  ERROR_API
} from './constants'

export const actionsExhibitedWork = {
  [SEARCH_EXHIBITION_SECTION_LIST] ({commit, state},
    { value, order, direction, page, itemsPerPage, begin, end }) {
    commit(FETCH_RESULT_LIST)
    let filters = [
      {
        property: 'search',
        matchType: 'cs',
        value: value.toLowerCase()
      }
    ]
    begin && filters.push({
      property: 'begin_date',
      matchType: 'ge',
      value: begin
    })
    end && filters.push({
      property: 'begin_date',
      matchType: 'le',
      value: end + '-12-31'
    })

    APIService.searchExhibitionSection({
      transform: true,
      filters,
      satisfy: 'all',
      order: {
        column: order || 'title',
        direction: direction || 'ASC'
      },
      page: {
        number: page,
        itemsPerPage
      }
    }).then(json => {
      commit(UPDATE_RESULT_LIST, {
        results: json.visu_exhibited_work || [],
        total: json._results || 0
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  },
  [GET_EXHIBITION_SECTION_FILTERED_BY_COLUMN] ({commit, state},
    { value, column, objectToIncrement }) {
    commit(FETCH_RESULT_FILTERED, {
      objectToIncrement,
      [column]: value
    })
    APIService.searchExhibitionSection({
      transform: true,
      filters: [
        {
          property: column,
          matchType: 'eq',
          value: value
        }
      ],
      order: {
        column: 'id',
        direction: 'ASC'
      },
      satisfy: 'all'
    }).then(json => {
      const catalogs = getCatalogs(json.visu_exhibition_section)
      commit(UPDATE_RESULT_FILTERED, {
        objectToIncrement,
        results: catalogs || []
      })
    }).catch((err) => {
      commit(ERROR_API, {
        error: err
      })
    })
  }
}

export default actionsExhibitedWork



// WEBPACK FOOTER //
// ./src/store/search/actions.exhibitionSection.js